import React from 'react'

import Home from './Home';
import Courses from './Courses';
import CourseSingle from './CourseSingle';
import Join from './Join';
import Login from './Login';
import LoginAs from './LoginAs';
import Logout from './Logout';
import RequestResetPassword from './RequestResetPassword';
import RetrieveMemberNo from './RetrieveMemberNo';
import RetrieveMemberDetails from './RetrieveMemberDetails';
import Contact from './Contact';
import ResetPassword from './ResetPassword';
import Member from './Member';
import Enrolments from './Enrolments';
import Invoices from './Invoices';
import Absences from './Absences';
import BuyMembership from './BuyMembership';
import Cart from './Cart';
import Checkout from './Checkout';

const pageComponents = {
	home: <Home />,
	courses: <Courses />,
	course: <CourseSingle />,
	member: <Member />,
	member_enrolments: <Enrolments />,
	member_invoices: <Invoices />,
	buy_membership: <BuyMembership />,
	member_absences: <Absences />,
	cart: <Cart />,
	checkout: <Checkout />,
	login: <Login />,
	login_as: <LoginAs />,
	login_reset_password: <RequestResetPassword />,
	login_retrieve_member_no: <RetrieveMemberNo />,
	login_retrieve_member_details: <RetrieveMemberDetails />,
	logout: <Logout />,
	join: <Join />,
	contact: <Contact />,
	reset_password: <ResetPassword />,
}

export default pageComponents;